/**
 * @fileoverview GET handler for the "/comments/:target/threads" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { commentsTargetThreads } from "./constants";
import type { GetCommentThreadsResult } from "./types";

export const getCommentThreads = reactQueryFetcherAdapter(
  commentsTargetThreads,
  (signal: AbortSignal, target: string, appGroupId: string): Promise<GetCommentThreadsResult> => {
    return fetch(`/comments/${target}/threads`, "GET", { app_group_id: appGroupId }, { signal });
  }
);
